export function getSelectedCartUnitPrice(cartItem = {}) {
  const quantity = Number(cartItem?.quantity) || 1;
  const designPrice = Number(cartItem?.design?.price);
  const sizePrice = Number(cartItem?.size?.price);
  const lineTotal = Number(cartItem?.lineTotal);
  const productPrice = Number(cartItem?.product?.price);

  if (Number.isFinite(designPrice) && designPrice > 0) return designPrice;
  if (Number.isFinite(sizePrice) && sizePrice > 0) return sizePrice;
  if (Number.isFinite(lineTotal) && lineTotal > 0) return lineTotal / quantity;
  if (Number.isFinite(productPrice) && productPrice > 0) return productPrice;
  return 0;
}

export function getSelectedCartLineTotal(cartItem = {}) {
  const quantity = Number(cartItem?.quantity) || 1;
  const lineTotal = Number(cartItem?.lineTotal);

  if (Number.isFinite(lineTotal) && lineTotal > 0) return lineTotal;
  return getSelectedCartUnitPrice(cartItem) * quantity + getSelectedCartExtraCharge(cartItem);
}

export function getSelectedCartExtraCharge(cartItem = {}) {
  const extraChargeAmount = Number(cartItem?.extraChargeAmount);

  if (
    cartItem?.extraChargeSelected &&
    Number.isFinite(extraChargeAmount) &&
    extraChargeAmount > 0
  ) {
    return extraChargeAmount;
  }

  return 0;
}

export function getSelectedCartStock(cartItem = {}) {
  const rawStock =
    cartItem?.design?.stockQuantity ??
    cartItem?.size?.stockQuantity ??
    cartItem?.product?.availableStock;
  const stock = Number(rawStock);

  return {
    hasStockLimit:
      rawStock !== undefined && rawStock !== null && Number.isFinite(stock),
    stock,
  };
}
